/**
 * Component types excluded from custom page rendering.
 * These don't have sortOrder or aren't valid custom page components.
 * RsvpAndUnlockGuestDetailsButtonComponent is now handled as a JSON component.
 * TODO: Remove this once these components are removed from the BE response.
 */
const INVALID_COMPONENT_TYPES = [
  'GreetingMessageComponent',
  'EventDisplayNameComponent',
  'RsvpAndUnlockGuestDetailsButtonComponent',
  'EventCountdownComponent',
  'EventDetailsComponent',
  'PlacesMapComponent',
] as const;

export type PagesToExclude =
  | { __typename?: 'EventDisplayNameComponent' }
  | { __typename?: 'GreetingMessageComponent' }
  | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' }
  | { __typename?: 'EventCountdownComponent' }
  | { __typename?: 'EventDetailsComponent' }
  | { __typename?: 'PlacesMapComponent' };

/**
 * Generic type guard for filtering out invalid component types from custom page component arrays.
 * Used by both the guest Custom widget and the admin CustomComponents editor.
 *
 * Also filters orphaned JsonDataBlobComponent records whose `containerContent` was never created.
 * These orphans cause a mount/remount loop when the editor tries to resolve a missing schema.
 */
export const filterInvalidComponents = <T extends { __typename?: string }>(component: T): component is Exclude<T, PagesToExclude> => {
  if (INVALID_COMPONENT_TYPES.includes(component.__typename as (typeof INVALID_COMPONENT_TYPES)[number])) {
    return false;
  }
  // Drop orphaned JsonDataBlobComponent records with no backing container data.
  // Mock components used in AddComponentList have no `id` and must pass through.
  if (component.__typename === 'JsonDataBlobComponent' && (component as T & { id?: string }).id && !(component as T & { containerContent?: unknown }).containerContent) {
    return false;
  }
  return true;
};
